import { dotDanhGiaLopReducer } from './danh-gia/dotDanhGiaLopReducer';
import { gioCongDongHoatDongReducer } from './gio-cong-dong/gioCongDongHoatDongReducer';
import { combineReducers } from "redux";
import { appPhuHuynhReducerWrapper } from './app-phuhuynh/appPhuHuynhReducerWrapper';
import { authReducer } from "./authReducer";
import { baiTapReducerWrapper } from './bai-tap/baiTapReducerWrapper';
import { baiVietDetailReducer } from './bai-viet/baiVietDetailReducer';
import { baiVietReducer } from './bai-viet/baiVietReducer';
import { baiVietTrangThaiReducer } from './bai-viet/baiVietTrangThaiReducer';
import { categorySourceReducer } from "./categorySourceReducer";
import { commonReducer } from "./commonReducer";
import { dgdkHocTapReducer } from './danh-gia/dinh-ky/dgdkHocTapReducer';
import { dgdkNlpcReducer } from './danh-gia/dinh-ky/dgdkNlpcReducer';
import { dgtxKetQuaMonHocReducer } from './danh-gia/thuong-xuyen/dgtxKetQuaMonHocReducer';
import { dgtxKetQuaReducer } from './danh-gia/thuong-xuyen/dgtxKetQuaReducer';
import { danhMucReducerWrapper } from './danh-muc/danhMucReducerWrapper';
import { giaoVienNhanXetReducer } from './danh-muc/giaoVienNhanXetReducer';
import { giaoVienReducer } from "./danh-muc/giaoVienReducer";
import { monHocReducer } from "./danh-muc/monHocReducer";
import { toKhoiReducer } from "./danh-muc/toKhoiReducer";
import { dictionaryReducer } from "./dictionaryReducer";
import { diemDanhReducer } from './diem-danh/diemDanhReducer';
import { diemDanhStatusReducer } from './diem-danh/diemDanhStatusReducer';
import { hocSinhReducer } from './hoc-sinh/hocSinhReducer';
import { localizedResourceReducer } from './localized-resource/localizedResourceReducer';
import { lopBoMonReducer } from './lop-bo-mon/lopBoMonReducer';
import { lopChuNhiemReducer } from './lop-chu-nhiem/lopChuNhiemReducer';
import { lopHanhChinhSoDiemReducer } from './lop-hanh-chinh/lopHanhChinhSoDiemReducer';
import { mappingReducer } from './mapping/mappingReducer';
import { nhanXetHangNgayReducer } from './nhan-xet/nhanXetHangNgayReducer';
import { thaiDoHocTapReducer } from './nhan-xet/thaiDoHocTapReducer';
import { thaiDoHocTapTieuChiReducer } from './nhan-xet/thaiDoHocTapTieuChiReducer';
import { nhapDiemReducer } from './nhap-diem/nhapDiemReducer';
import { notifyReducer } from './notify/notifyReducer';
import { loaiPhongReducer } from './phong-hoc/loaiPhongReducer';
import { phongHocReducer } from './phong-hoc/phongHocReducer';
import { soNhanXetReducer } from './so-diem-tieu-hoc/dinh-ky/soNhanXetReducer';
import { soNhanXetItemReducer } from './so-diem-tieu-hoc/soNhanXetItemReducer';
import { monHocSoDiemReducer } from './so-diem/monHocSoDiemReducer';
import { soDiemReducerWrapper } from './so-diem/soDiemReducerWrapper';
import { thoiKhoaBieuReducerWrapper } from './thoi-khoa-bieu/thoiKhoaBieuReducerWrapper';
import { thoiKhoaBieuViewReducer } from './thoi-khoa-bieu/thoiKhoaBieuViewReducer';
import { uploadReducer } from './upload-file/uploadReducer';

import { baiVietCommentReducer } from "./bai-viet-comment/baiVietCommentReducer";
import { baoCaoTienBoReducer } from './bao-cao-tien-bo/baoCaoTienBoReducer';
import { chamTietLoaiTietReducer } from './cham-tiet/chamTietLoaiTietReducer';
import { chamTietReducer } from './cham-tiet/chamTietReducer';
import { appConfigReducer } from "./common/appConfigReducer";
import { ychtGroupReducer } from './danh-muc/ychtGroupReducer';
import { diemVanMinhKetQuaReducer } from './diemvanminh-ketqua/diemVanMinhKetQuaReducer';
import { diemVanMinhTieuChiReducer } from './diemvanminh-tieuchi/diemVanMinhTieuChiReducer';
import { lopMonHocReducer } from './lop-mon-hoc/lopMonHocReducer';
import { tongHopDinhKyReducer } from "./tong-hop/tongHopDinhKyReducer";
import { xepHangHocSinhReducer } from './xep-hang-hoc-sinh/xepHangHocSinhReducer';
import { gioCongDongReducer } from "./gio-cong-dong/gioCongDongReducer";
import { cuocThaoLuanReducer } from './cuoc-thao-luan/cuocThaoLuanReducer';
import { theoDoiRCReducer } from './theo-doi-rc/theoDoiRCReducer';
import { legalGroupReducer } from './legal-document/legalGroupReducer';
import { legalDocumentReducer } from './legal-document/legalDocumentReducer';
import { chieuCaoCanNangReducer } from './dan-thuoc/chieuCaoCanNangReducer';
import { dgTuanKetQuaReducer } from './danh-gia/tuan/dgTuanKetQuaReducer';
import { hoatDongHangNgayReducer } from './danh-gia/hoatDongHangNgayReducer';
import { dotDanhGiaReducer } from './danh-gia/dotDanhGiaReducer';
const reducers = combineReducers({
    auth: authReducer,
    appConfig: appConfigReducer,
    appPhuHuynhWrapper: appPhuHuynhReducerWrapper,
    dictionary: dictionaryReducer,
    categorySource: categorySourceReducer,
    common: commonReducer,
    monHoc: monHocReducer,
    ychtGroupReducer,
    lopBoMon: lopBoMonReducer,
    hocSinh: hocSinhReducer,
    soDiem: soDiemReducerWrapper,
    toKhoi: toKhoiReducer,
    giaoVien: giaoVienReducer,
    soNhanXet: soNhanXetReducer,
    soNhanXetItem: soNhanXetItemReducer,
    giaoVienNhanXet: giaoVienNhanXetReducer,
    loaiPhong: loaiPhongReducer,
    phongHoc: phongHocReducer,
    thoiKhoaBieuWrapper: thoiKhoaBieuReducerWrapper,
    danhMucWrapper: danhMucReducerWrapper,
    uploadFile: uploadReducer,
    baiViet: baiVietReducer,
    baiVietTrangThai: baiVietTrangThaiReducer,
    baiVietDetail: baiVietDetailReducer,
    notify: notifyReducer,
    diemDanh: diemDanhReducer,
    diemDanhStatus: diemDanhStatusReducer,
    nhanXetHangNgay: nhanXetHangNgayReducer,
    hoatDongHangNgay: hoatDongHangNgayReducer,
    localizedResource: localizedResourceReducer,
    baiTapWrapper: baiTapReducerWrapper,
    nhapDiem: nhapDiemReducer,
    monHocSoDiem: monHocSoDiemReducer,
    lopChuNhiem: lopChuNhiemReducer,
    mapping: mappingReducer,
    thaiDoHocTapWrapper: combineReducers({
        thaiDoHocTap: thaiDoHocTapReducer,
        thaiDoHocTapTieuChi: thaiDoHocTapTieuChiReducer
    }),
    diemVanMinhTieuChi: diemVanMinhTieuChiReducer,
    diemVanMinhKetQua: diemVanMinhKetQuaReducer,
    dgdkNlpc: dgdkNlpcReducer,
    dgtxKetQua: dgtxKetQuaReducer,
    dgdkHocTap: dgdkHocTapReducer,
    dgTuan: dgTuanKetQuaReducer,
    dgtxKetQuaMonHoc: dgtxKetQuaMonHocReducer,
    lopHanhChinhSoDiem: lopHanhChinhSoDiemReducer,
    baoCaoTienBo: baoCaoTienBoReducer,
    xepHangHocSinh: xepHangHocSinhReducer,
    lopMonHoc: lopMonHocReducer,
    tongHop: combineReducers({
        dinhKy: tongHopDinhKyReducer
    }),
    baiVietComment: baiVietCommentReducer,
    thoiKhoaBieuView: thoiKhoaBieuViewReducer,
    chamTietLoaiTiet: chamTietLoaiTietReducer,
    chamTiet: chamTietReducer,
    gioCongDongReducer: combineReducers({
        gioCongDong: gioCongDongReducer,
        hoatDong: gioCongDongHoatDongReducer
    }),
    cuocThaoLuan: cuocThaoLuanReducer,
    theoDoiRCReducer,
    legalDocument: combineReducers({
        group: legalGroupReducer,
        documents: legalDocumentReducer
    }),
    danThuoc: combineReducers({
        chieuCaoCanNangReducer
    }),
    danhGia: combineReducers({
        dotDanhGia: dotDanhGiaReducer,
        dotDanhGiaLop: dotDanhGiaLopReducer
    }),

})

export default reducers

export type RootState = ReturnType<typeof reducers>